export default __webpack_public_path__ + "static/media/uploader-ascensiaContour-problem-1.cf4b6b9f.png";